// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from "firebase/app";

// Add the Firebase services that you want to use
// We only want to use Firebase Auth here

import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

// Your app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyAyRivZt24xp2Po5fm00fEJVHl3aJzcMAA",
  authDomain: "sthal-de0b2.firebaseapp.com",
  databaseURL: "https://sthal-de0b2.firebaseio.com",
  projectId: "sthal-de0b2",
  storageBucket: "sthal-de0b2.appspot.com",
  messagingSenderId: "568364189957",
  appId: "1:568364189957:web:ade40f181512ddc2004f6c",
  measurementId: "G-B7E9ZL144L"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.firestore().settings({ timestampsInSnapshots: true });
// Finally, export it to use it throughout your app

export const myFirestore = firebase.firestore();
export const myStorage = firebase.storage();
export const myFirebase = firebase;